import { request } from 'umi';

export const setDefaultRelation = async (relationId: number) => {
  return request('/account/relations/set-default', {
    method: 'POST',
    data: { id: relationId },
    skipErrorHandler: true,
  })
    .then(() => undefined)
    .catch(() => undefined);
};
